import * as React from "react";

import style from "./LinkDialog.module.scss";

export interface LinkDialogStateProps {}

export interface LinkDialogDispatchProps {
  callback: (title: string, url: string) => void;
  closeModal: () => void;
}

export interface LinkDialogProps
  extends LinkDialogDispatchProps,
    LinkDialogStateProps {}

export const LinkDialog = (props: LinkDialogProps) => {
  const [state, setState] = React.useState({ title: "", url: "" });
  return (
    <main className={style.main}>
      <div className={style.header}>
        <div className={style.title}>リンクの挿入</div>
        <div className="mb-3">
          <label className="form-label" htmlFor="title">
            タイトル
          </label>
          <div className="input-group">
            <input
              type="text"
              name="title"
              placeholder="記事名etc."
              className={"form-control"}
              id="title"
              value={state.title}
              onChange={e => setState({ ...state, title: e.target.value })}
            />
          </div>
        </div>
        <div className="mb-3">
          <label className="form-label" htmlFor="url">
            URL
          </label>
          <div className="input-group">
            <input
              type="text"
              name="url"
              className={"form-control"}
              placeholder="https://www.enageed.jp/"
              id="url"
              value={state.url}
              onChange={e => setState({ ...state, url: e.target.value })}
            />
          </div>
        </div>
      </div>
      <div className={style.body}>
        <div className={style.btnArea}>
          <button
            className="btn btn-secondary"
            onClick={() => props.closeModal()}
          >
            {"キャンセル"}
          </button>
          <button
            className={"btn " + style.okBtn}
            onClick={() => {
              props.callback(state.title, state.url);
              props.closeModal();
            }}
          >
            {"OK"}
          </button>
        </div>
      </div>
    </main>
  );
};

export default LinkDialog;
